import type LocationSuggestionsCache from './schema/LocationSuggestionsCache';
import getDefaultPickerState from 'owa-location-common-well/lib/utils/getDefaultPickerState';
import { createStore } from 'satcheljs';

const defaultLocationPickerState: LocationSuggestionsCache = {
    locationSuggestionsState: getDefaultPickerState(),
};

export const getStore = createStore<LocationSuggestionsCache>(
    'LocationPickerStore',
    defaultLocationPickerState
);
export default getStore;
